module.exports = __webpack_public_path__ + "img/avada-food-logo-mob-2x-200x87.57385e21.png";